<template>
    <div>
        <!-- 标题 -->
        <center-title>{{$t("message.ccall.title")}}</center-title>
        <!-- 表格 -->
        <call-table></call-table>
        <!-- 表单 -->
        <div class="center_call_form" v-if="character_id == 2 && !power.includes(0)">
            <center-add-title>{{$t("message.ccall.subtitle")}}</center-add-title>
            <call-form></call-form>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex"

export default {
    computed: mapState({
        user_info: state => state.user.user_info,
        power: state => state.user.power,
        character_id: state => state.user.character_id
    }),
    components: {
        centerTitle: () => import("@/components/center/centerTitle"),
        callTable: () => import("@/components/center/callTable"),
        centerAddTitle: () => import("@/components/center/centerAddTitle"),
        callForm: () => import("@/components/center/callForm"),
    },
    methods: {
        ...mapMutations([
            "setCallcenterList",
            "setCalluserList"
        ]),
        ...mapActions([
            "getCallcenterList",
            "getCalluserList"
        ]),
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
			setTimeout(() => {
				let allow = vm.character_id == 2 || vm.character_id == 6;
				if(allow){
				    vm.getCallcenterList();
				    vm.getCalluserList(vm.user_info.company_id);
				}else{
				    vm.$router.back();
				    return false;
				}
			}, 500)
        })
    },
    beforeRouteLeave (to, from, next) {
        this.setCallcenterList([]);
        this.setCalluserList([]);
        next();
    }
}
</script>

<style scoped>
.center_call_form{
    margin-top: 30px;
    padding-bottom: 20px;
    background: #fff
}
</style>
